(function () {
  const initBrandTicker = (section) => {
    if (section.dataset.brandScrollbarReady === 'true') return;

    const track = section.querySelector('.brands-items');
    const range = section.querySelector('.brands-scrollbar__input');
    const brands = section.querySelector('.brands');

    if (!track || !range || !brands) return;

    section.dataset.brandScrollbarReady = 'true';

    let position = 0;
    let maxScroll = 0;
    let lastTime = 0;
    let isDragging = false;
    let isHovering = false;
    let resumeTimer;

    const speedSeconds = Number(brands.dataset.brandsSpeed) || 25;

    const updateMaxScroll = () => {
      maxScroll = Math.max(track.scrollWidth - brands.clientWidth, 0);
    };

    const setPosition = (nextPosition) => {
      updateMaxScroll();

      if (maxScroll <= 0) {
        position = 0;
      } else {
        position = nextPosition;

        if (position > maxScroll) {
          position = 0;
        }

        if (position < 0) {
          position = maxScroll;
        }
      }

      track.style.transform = `translateX(-${position}px)`;
      range.value = maxScroll ? Math.round((position / maxScroll) * Number(range.max)) : 0;
    };

    const autoScroll = (time) => {
      if (!lastTime) lastTime = time;

      const elapsed = time - lastTime;
      lastTime = time;

      if (!isDragging && !isHovering) {
        const pixelsPerMillisecond = maxScroll / (speedSeconds * 1000);
        setPosition(position + elapsed * pixelsPerMillisecond);
      }

      requestAnimationFrame(autoScroll);
    };

    range.addEventListener('input', () => {
      isDragging = true;
      window.clearTimeout(resumeTimer);
      updateMaxScroll();
      setPosition((Number(range.value) / Number(range.max)) * maxScroll);
    });

    range.addEventListener('change', () => {
      resumeTimer = window.setTimeout(() => {
        isDragging = false;
      }, 1200);
    });

    brands.addEventListener('mouseenter', () => {
      isHovering = true;
    });

    brands.addEventListener('mouseleave', () => {
      isHovering = false;
    });

    window.addEventListener('resize', () => {
      setPosition(position);
    });

    updateMaxScroll();
    setPosition(0);
    requestAnimationFrame(autoScroll);
  };

  const initAllBrandTickers = () => {
    document.querySelectorAll('.brands-section').forEach(initBrandTicker);
  };

  document.addEventListener('DOMContentLoaded', initAllBrandTickers);
  document.addEventListener('shopify:section:load', initAllBrandTickers);
})();